import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddBalancesMutationVariables = Types.Exact<{
  objects: Array<Types.Actual_Balances_Insert_Input>;
}>;

export type AddBalancesMutation = { __typename?: "mutation_root" } & {
  insert_actual_balances?: Types.Maybe<
    { __typename?: "actual_balances_mutation_response" } & Pick<
      Types.Actual_Balances_Mutation_Response,
      "affected_rows"
    >
  >;
};

export const AddBalancesDocument = gql`
  mutation AddBalances($objects: [actual_balances_insert_input!]!) {
    insert_actual_balances(
      objects: $objects
      on_conflict: {
        constraint: actual_balances_date_bank_account_id_key
        update_columns: [balance, balance_gbp, interest_rate, maturity_date]
      }
    ) {
      affected_rows
    }
  }
`;

export function useAddBalancesMutation() {
  return Urql.useMutation<AddBalancesMutation, AddBalancesMutationVariables>(
    AddBalancesDocument
  );
}
